import PalletsTransferHistory from 'components/PalletsTransferHistory/PalletsTransferHistory';
import WithAuth from 'hoc/withAuth';

const PalletsTransferHistoryPage = () => <PalletsTransferHistory mode="ROLE_STORAGE" />;

export default WithAuth(PalletsTransferHistoryPage, 'ROLE_STORAGE');
